// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var MM_parser = require("../mm-utils/MM_parser.bs.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var MM_context = require("../mm-utils/MM_context.bs.js");
var Belt_MapInt = require("rescript/lib/js/belt_MapInt.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var MM_wrk_editor = require("../worker/MM_wrk_editor.bs.js");
var Expln_React_Row = require("@expln/utils/src/main/react-mui-components/Expln_React_Row.bs.js");
var Expln_React_Modal = require("@expln/utils/src/main/react-components/Expln_React_Modal.bs.js");
var Expln_React_Column = require("@expln/utils/src/main/react-mui-components/Expln_React_Column.bs.js");
var Expln_React_common = require("@expln/utils/src/main/Expln_React_common.bs.js");
var Paper = require("@mui/material/Paper").default;
var Expln_utils_promise = require("@expln/utils/src/main/Expln_utils_promise.bs.js");
var Button = require("@mui/material/Button").default;
var Checkbox = require("@mui/material/Checkbox").default;
var TextField = require("@mui/material/TextField").default;
var IconButton = require("@mui/material/IconButton").default;
var SwapVert = require("@mui/icons-material/SwapVert").default;

function makeInitialState(expr1Init, expr2Init) {
  return {
          expr1Str: Belt_Option.getWithDefault(expr1Init, ""),
          expr1Err: undefined,
          expr2Str: Belt_Option.getWithDefault(expr2Init, ""),
          expr2Err: undefined,
          results: undefined,
          checkedResultIdx: undefined,
          invalidResults: undefined
        };
}

function setResults(st, results) {
  return {
          expr1Str: st.expr1Str,
          expr1Err: st.expr1Err,
          expr2Str: st.expr2Str,
          expr2Err: st.expr2Err,
          results: results.filter(function (res) {
                return Belt_Option.isNone(res.err);
              }),
          checkedResultIdx: results.length === 1 ? 0 : undefined,
          invalidResults: results.filter(function (res) {
                return Belt_Option.isSome(res.err);
              })
        };
}

function setExpr1Str(st, str) {
  return {
          expr1Str: str,
          expr1Err: st.expr1Err,
          expr2Str: st.expr2Str,
          expr2Err: st.expr2Err,
          results: st.results,
          checkedResultIdx: st.checkedResultIdx,
          invalidResults: st.invalidResults
        };
}

function setExpr2Str(st, str) {
  return {
          expr1Str: st.expr1Str,
          expr1Err: st.expr1Err,
          expr2Str: str,
          expr2Err: st.expr2Err,
          results: st.results,
          checkedResultIdx: st.checkedResultIdx,
          invalidResults: st.invalidResults
        };
}

function swapExprs(st) {
  return {
          expr1Str: st.expr2Str,
          expr1Err: undefined,
          expr2Str: st.expr1Str,
          expr2Err: undefined,
          results: st.results,
          checkedResultIdx: st.checkedResultIdx,
          invalidResults: st.invalidResults
        };
}

function toggleResultChecked(st, idx) {
  if (Caml_obj.equal(st.checkedResultIdx, idx)) {
    return {
            expr1Str: st.expr1Str,
            expr1Err: st.expr1Err,
            expr2Str: st.expr2Str,
            expr2Err: st.expr2Err,
            results: st.results,
            checkedResultIdx: undefined,
            invalidResults: st.invalidResults
          };
  } else {
    return {
            expr1Str: st.expr1Str,
            expr1Err: st.expr1Err,
            expr2Str: st.expr2Str,
            expr2Err: st.expr2Err,
            results: st.results,
            checkedResultIdx: idx,
            invalidResults: st.invalidResults
          };
  }
}

function rndIconButton(icon, onClick, active, title, param) {
  var tmp = {};
  if (title !== undefined) {
    tmp.title = Caml_option.valFromOption(title);
  }
  return React.createElement("span", tmp, React.createElement(IconButton, {
                  onClick: (function (param) {
                      Curry._1(onClick, undefined);
                    }),
                  color: "primary",
                  disabled: !active,
                  children: icon
                }));
}

function MM_cmp_substitution(Props) {
  var modalRef = Props.modalRef;
  var editorState = Props.editorState;
  var expr1Init = Props.expr1Init;
  var expr2Init = Props.expr2Init;
  var wrkCtx = Props.wrkCtx;
  var onCanceled = Props.onCanceled;
  var onSubstitutionSelected = Props.onSubstitutionSelected;
  var match = React.useState(function () {
        return makeInitialState(expr1Init, expr2Init);
      });
  var setState = match[1];
  var state = match[0];
  var actExpr1Change = function (str) {
    Curry._1(setState, (function (__x) {
            return setExpr1Str(__x, str);
          }));
  };
  var actExpr2Change = function (str) {
    Curry._1(setState, (function (__x) {
            return setExpr2Str(__x, str);
          }));
  };
  var rndError = function (msgOpt) {
    if (msgOpt !== undefined) {
      return React.createElement("pre", {
                  style: {
                    color: "red"
                  }
                }, msgOpt);
    } else {
      return null;
    }
  };
  var rndExpr = function (label, value, autoFocus, onChange, tabIndex) {
    return React.createElement(TextField, {
                value: value,
                label: label,
                size: "small",
                style: {
                  width: "700px"
                },
                onChange: (function (param) {
                    return Expln_React_common.evt2str(onChange, param);
                  }),
                inputProps: {
                  tabIndex: tabIndex
                },
                autoFocus: autoFocus
              });
  };
  var rndInput = function (param) {
    return React.createElement(Expln_React_Column.make, {
                children: null
              }, React.createElement("table", undefined, React.createElement("tbody", undefined, React.createElement("tr", undefined, React.createElement("td", undefined, rndExpr("Replace what", state.expr1Str, true, actExpr1Change, 1)), React.createElement("td", undefined, rndIconButton(React.createElement(SwapVert, {}), (function (param) {
                                      Curry._1(setState, swapExprs);
                                    }), true, "Swap \"Replace what\" and \"Replace with\"", undefined))))), rndError(state.expr1Err), rndExpr("Replace with", state.expr2Str, false, actExpr2Change, 2), rndError(state.expr2Err), React.createElement(Expln_React_Row.make, {
                    children: null
                  }, React.createElement(Button, {
                        onClick: (function (param) {
                            var findIncorrectSymbol = function (syms) {
                              return Caml_option.undefined_to_opt(syms.find(function (sym) {
                                              return !(MM_context.isConst(wrkCtx, sym) || MM_context.isVar(wrkCtx, sym));
                                            }));
                            };
                            var syms1 = MM_parser.getSpaceSeparatedValuesAsArray(state.expr1Str);
                            var incorrectSymbol1 = findIncorrectSymbol(syms1);
                            var syms2 = MM_parser.getSpaceSeparatedValuesAsArray(state.expr2Str);
                            var incorrectSymbol2 = findIncorrectSymbol(syms2);
                            Curry._1(setState, (function (st) {
                                    var st$1 = incorrectSymbol1 !== undefined ? ({
                                          expr1Str: st.expr1Str,
                                          expr1Err: "Unknown symbol - '" + incorrectSymbol1 + "'",
                                          expr2Str: st.expr2Str,
                                          expr2Err: st.expr2Err,
                                          results: st.results,
                                          checkedResultIdx: st.checkedResultIdx,
                                          invalidResults: st.invalidResults
                                        }) : ({
                                          expr1Str: st.expr1Str,
                                          expr1Err: undefined,
                                          expr2Str: st.expr2Str,
                                          expr2Err: st.expr2Err,
                                          results: st.results,
                                          checkedResultIdx: st.checkedResultIdx,
                                          invalidResults: st.invalidResults
                                        });
                                    if (incorrectSymbol2 !== undefined) {
                                      return {
                                              expr1Str: st$1.expr1Str,
                                              expr1Err: st$1.expr1Err,
                                              expr2Str: st$1.expr2Str,
                                              expr2Err: "Unknown symbol - '" + incorrectSymbol2 + "'",
                                              results: st$1.results,
                                              checkedResultIdx: st$1.checkedResultIdx,
                                              invalidResults: st$1.invalidResults
                                            };
                                    } else {
                                      return {
                                              expr1Str: st$1.expr1Str,
                                              expr1Err: st$1.expr1Err,
                                              expr2Str: st$1.expr2Str,
                                              expr2Err: undefined,
                                              results: st$1.results,
                                              checkedResultIdx: st$1.checkedResultIdx,
                                              invalidResults: st$1.invalidResults
                                            };
                                    }
                                  }));
                            if (!(Belt_Option.isNone(incorrectSymbol1) && Belt_Option.isNone(incorrectSymbol2))) {
                              return ;
                            }
                            var results = MM_wrk_editor.findPossibleSubs(editorState, MM_context.ctxSymsToIntsExn(wrkCtx, syms1), MM_context.ctxSymsToIntsExn(wrkCtx, syms2));
                            Curry._1(setState, (function (__x) {
                                    return setResults(__x, results);
                                  }));
                          }),
                        variant: "outlined",
                        children: "Extract substitution"
                      }), React.createElement(Button, {
                        onClick: (function (param) {
                            Curry._1(onCanceled, undefined);
                          }),
                        children: "Cancel"
                      })));
  };
  var rndResultButtons = function (param) {
    var results = state.results;
    if (results === undefined) {
      return null;
    }
    var numOfResults = results.length;
    if (numOfResults > 0) {
      return React.createElement(Expln_React_Row.make, {
                  children: null
                }, React.createElement(Button, {
                      onClick: (function (param) {
                          var results = state.results;
                          if (results === undefined) {
                            return ;
                          }
                          var idx = state.checkedResultIdx;
                          if (idx !== undefined && 0 <= idx && idx < results.length) {
                            return Curry._1(onSubstitutionSelected, Caml_array.get(results, idx));
                          }
                          
                        }),
                      variant: "contained",
                      disabled: Belt_Option.isNone(state.checkedResultIdx),
                      children: numOfResults === 1 ? "Apply" : "Apply selected"
                    }), React.createElement(Button, {
                      onClick: (function (param) {
                          Curry._1(onCanceled, undefined);
                        }),
                      children: "Cancel"
                    }));
    } else {
      return null;
    }
  };
  var rndNewDisj = function (wrkSubs) {
    if (MM_context.disjIsEmpty(wrkSubs.newDisj)) {
      return null;
    }
    var tableRows = [];
    MM_context.disjForEachArr(wrkSubs.newDisj, (function (disjGrp) {
            var disjGrpStr = "$d " + MM_context.ctxIntsToStrExn(wrkCtx, disjGrp) + " $.";
            tableRows.push(React.createElement("tr", {
                      key: disjGrpStr
                    }, React.createElement("td", undefined, disjGrpStr)));
          }));
    return React.createElement("table", undefined, React.createElement("tbody", undefined, tableRows));
  };
  var rndSubs = function (wrkSubs) {
    return React.createElement("table", undefined, React.createElement("tbody", undefined, Belt_MapInt.toArray(wrkSubs.subs).map(function (param) {
                        var expr = param[1];
                        var v = param[0];
                        if (expr.length === 1 && v === Caml_array.get(expr, 0)) {
                          return null;
                        } else {
                          return React.createElement("tr", {
                                      key: String(v)
                                    }, React.createElement("td", undefined, MM_context.ctxIntToSymExn(wrkCtx, v)), React.createElement("td", undefined, "\u2192"), React.createElement("td", undefined, MM_context.ctxIntsToStrExn(wrkCtx, expr)));
                        }
                      })));
  };
  var rndSubsErr = function (err) {
    if (err === undefined) {
      return null;
    }
    var errDescr;
    errDescr = err.TAG === /* CommonVar */0 ? "substitutions for " + MM_context.ctxIntToSymExn(wrkCtx, err.var1) + " and " + MM_context.ctxIntToSymExn(wrkCtx, err.var2) + " " + ("have common variable " + MM_context.ctxIntToSymExn(wrkCtx, err.commonVar) + "") : "could not prove [" + MM_context.ctxIntsToStrExn(wrkCtx, err.typeExpr) + "] for " + MM_context.ctxIntToSymExn(wrkCtx, err.var) + " " + String.fromCharCode(8594) + (" [" + MM_context.ctxIntsToStrExn(wrkCtx, err.subsExpr) + "]");
    return React.createElement("div", undefined, React.createElement("span", {
                    style: {
                      color: "red"
                    }
                  }, "Error: "), errDescr);
  };
  var rndWrkSubs = function (wrkSubs) {
    return React.createElement(React.Fragment, undefined, rndNewDisj(wrkSubs), rndSubs(wrkSubs), rndSubsErr(wrkSubs.err));
  };
  var getNumberOfResults = function (arrOpt) {
    return Belt_Option.getWithDefault(Belt_Option.map(arrOpt, (function (arr) {
                      return arr.length;
                    })), 0);
  };
  var rndResults = function (param) {
    var results = state.results;
    if (results === undefined) {
      return null;
    }
    var numOfInvalidResults = getNumberOfResults(state.invalidResults);
    var summary = React.createElement(React.Fragment, undefined, "Found substitutions: " + ("" + String(getNumberOfResults(state.results)) + " valid, "), numOfInvalidResults === 0 ? "0 invalid." : React.createElement("span", {
                style: {
                  color: "blue",
                  cursor: "pointer"
                },
                onClick: (function (param) {
                    var invalidResults = state.invalidResults;
                    if (invalidResults !== undefined) {
                      Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function (param) {
                                  return null;
                                })), (function (modalId) {
                              Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                                      return React.createElement(Expln_React_Column.make, {
                                                  spacing: 1,
                                                  style: {
                                                    margin: "10px"
                                                  },
                                                  children: null
                                                }, React.createElement("span", {
                                                      style: {
                                                        fontWeight: "bold"
                                                      }
                                                    }, "Invalid substitutions:"), invalidResults.map(function (res, i) {
                                                      return React.createElement(Paper, {
                                                                  children: React.createElement("table", undefined, React.createElement("tbody", undefined, React.createElement("tr", undefined, React.createElement("td", undefined, rndWrkSubs(res))))),
                                                                  key: String(i)
                                                                });
                                                    }), React.createElement(Button, {
                                                      onClick: (function (param) {
                                                          Expln_React_Modal.closeModal(modalRef, modalId);
                                                        }),
                                                      variant: "contained",
                                                      children: "Close"
                                                    }));
                                    }));
                            }));
                      return ;
                    }
                    
                  })
              }, String(numOfInvalidResults) + " invalid."));
    var numOfResults = results.length;
    return React.createElement(Expln_React_Column.make, {
                children: null
              }, summary, results.map(function (res, i) {
                    return React.createElement(Paper, {
                                children: React.createElement("table", undefined, React.createElement("tbody", undefined, React.createElement("tr", undefined, numOfResults > 1 ? React.createElement("td", undefined, React.createElement(Checkbox, {
                                                        checked: Caml_obj.equal(state.checkedResultIdx, i),
                                                        onChange: (function (param) {
                                                            Curry._1(setState, (function (__x) {
                                                                    return toggleResultChecked(__x, i);
                                                                  }));
                                                          })
                                                      })) : null, React.createElement("td", undefined, rndWrkSubs(res))))),
                                key: String(i)
                              });
                  }), rndResultButtons(undefined));
  };
  return React.createElement(Paper, {
              style: {
                padding: "10px"
              },
              children: React.createElement(Expln_React_Column.make, {
                    spacing: 1,
                    children: null
                  }, rndInput(undefined), rndResults(undefined))
            });
}

var make = MM_cmp_substitution;

exports.makeInitialState = makeInitialState;
exports.setResults = setResults;
exports.setExpr1Str = setExpr1Str;
exports.setExpr2Str = setExpr2Str;
exports.swapExprs = swapExprs;
exports.toggleResultChecked = toggleResultChecked;
exports.rndIconButton = rndIconButton;
exports.make = make;
/* react Not a pure module */
